import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { runLogSchema } from './../models/runLog.schema';

export const runLogs = (runUuid: string) => {
  return {
    endpoint: `/hooks/runs/${runUuid}/logs`,
    method: 'GET',
    responseSchema: listResponse(runLogSchema),
    query: { includeTotal: true },
    querySchema: z.object({ includeTotal: z.boolean().optional() }),
  } as const;
};
